<template>
  <v-img
    class="event-highlights__featured-image"
    v-if="!isLoading"
    cover
    :aspect-ratio="1"
    :src="image.event_medium.uploaded_file.original.url"
    style="cursor: pointer"
    @click="$emit('click')"
  />
  <GalleryViewSkeletonLoader v-else></GalleryViewSkeletonLoader>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from "vue"
import { Highlight } from "suus-api"
import GalleryViewSkeletonLoader from "features/gallery/view/GalleryViewSkeletonLoader.vue"

export default defineComponent({
  name: "EventHighlightsFeaturedImage",
  components: { GalleryViewSkeletonLoader },
  props: {
    image: {
      type: Object as PropType<Highlight>,
      required: false,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const isLoading = computed(() => {
      return props.loading || !props.image
    })

    console.log("image", props.image)

    return {
      isLoading,
    }
  },
})
</script>

<style scoped>
.event-highlights__featured-image {
  border-radius: 4px;
}
</style>
